"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.menuItemsMock = void 0;
exports.menuItemsMock = [
    { icon: 'dashboard', label: 'Dashboard', onClick: alert },
    { icon: 'calendar', label: 'Calendar', onClick: alert }
];
//# sourceMappingURL=menu-item.js.map